import { useQuery } from "@tanstack/react-query";
import returnsService from "services/admin/returnsService";

export const useGetReturnsByOrgID = (orgID, queryParams = {}) => {
    return useQuery({
        queryKey: ['getReturnsByOrgID', orgID, queryParams],
        queryFn: async () => {
            const { data } = await returnsService.getAllByOrgID(orgID, queryParams);
            return data;
        },
        select: (data) => data.rows,
        refetchOnWindowFocus: false,
    });
};